"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessIcon = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _ref =
/*#__PURE__*/
(0, _jsx2["default"])("svg", {
  width: "59",
  height: "59",
  viewBox: "0 0 59 59",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, (0, _jsx2["default"])("circle", {
  cx: "28",
  cy: "28",
  r: "28",
  fill: "#B3F4D9"
}), (0, _jsx2["default"])("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31 4.75C16.5024 4.75 4.75 16.5024 4.75 31C4.75 45.4976 16.5024 57.25 31 57.25C45.4976 57.25 57.25 45.4976 57.25 31C57.25 16.5024 45.4976 4.75 31 4.75ZM3 31C3 15.5359 15.5359 3 31 3C46.4641 3 59 15.5359 59 31C59 46.4641 46.4641 59 31 59C15.5359 59 3 46.4641 3 31ZM45.6187 23.3813C45.9604 23.723 45.9604 24.277 45.6187 24.6187L30.3062 39.9312C29.9645 40.2729 29.4105 40.2729 29.0688 39.9312L19.8813 30.7437C19.5396 30.402 19.5396 29.848 19.8813 29.5063C20.223 29.1646 20.777 29.1646 21.1187 29.5063L29.6875 38.0751L44.3813 23.3813C44.723 23.0396 45.277 23.0396 45.6187 23.3813Z",
  fill: "#33174D"
}));

var SuccessIcon = function SuccessIcon() {
  return _ref;
};

exports.SuccessIcon = SuccessIcon;